import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { EATableRow } from "../../../models/EATable";

/* eslint-disable import/no-anonymous-default-export */
export default (data: EATableRow[], onSelectionChange: (selectedRows: EATableRow[]) => void) => {
  const { t } = useTranslation();
  const [selectedRows, setSelectedRows] = useState<Set<number>>(new Set());
  const [selectAll, setSelectAll] = useState<boolean>(false);

  const handleCheckboxChange = (rowIndex: number) => {
    const newSelectedRows = new Set(selectedRows);
    if (newSelectedRows.has(rowIndex)) {
      newSelectedRows.delete(rowIndex);
    } else {
      newSelectedRows.add(rowIndex);
    }
    setSelectedRows(newSelectedRows);
    setSelectAll(newSelectedRows.size === data.length);
  };

  const toggleSelectAll = (checked: boolean) => {
    const newSelectedRows = new Set<number>();
    if (checked) {
      data.forEach((_, index) => newSelectedRows.add(index));
    }
    setSelectedRows(newSelectedRows);
    setSelectAll(checked);
  };

  const renderCellValue = (value: any, type?: string) => {
    switch (type) {
      case "price":
        return `${value} ${t("zl")}`; // Dodajemy "zł" do wartości
      default:
        return value; // Domyślne formatowanie
    }
  };

  // Wywołanie onSelectionChange, gdy selectedRows się zmienia
  useEffect(() => {
    if (onSelectionChange) {
      const selectedData = Array.from(selectedRows).map((index) => data[index]);
      onSelectionChange(selectedData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRows]);

  return {
    handleCheckboxChange,
    renderCellValue,
    selectedRows,
    selectAll,
    setSelectAll: toggleSelectAll,
  };
};
